/**
 * Created by JasonChou on 17/6/19.
 */
import React, {PureComponent} from 'react'
export default class InfiniteScroll extends PureComponent {
    state = {loading: false};

    componentDidMount() {
        this.handler = setInterval(this._listen, 50)
    }

    _listen = async () => {
        if (!this.state.loading) {
            const d = this.refs['scroll'].clientHeight - this.refs['wrapper'].clientHeight - window.pageYOffset; //ios bug this.refs['wrapper'].scrollTop;

            if (d >= 0 && d < 100) {
                if (this.props.onLoadMore) {
                    this.setState({loading: true});
                    await this.props.onLoadMore();
                    this.setState({loading: false});
                }
            }
        }
    };

    componentWillUnmount() {
        clearInterval(this.handler);
        this.handler = null;
    }

    render() {
        return <div ref="wrapper" style={Object.assign({}, this.props.style)}
                    name="InfiniteScrollWrapper">
            <div ref='scroll' name="InfiniteScroll">{this.props.children}</div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/InfiniteScroll.js